import React, { useState, useEffect } from "react";
import { Line } from "@ant-design/plots";
import * as Global from "../../styles/Global";

const LinePlot = ({ style, data, x, y, autoHeight, type, total }) => {
  //console.log("LinePlotdata: ", data);

  let config = {
    data,
    xField: x ? x : "dataPoint",
    yField: y ? y : "value",
    autoFit: true,
    height: autoHeight ? null : 100,
    label: {
      // offset: type === "rank" ? 15 : -15,
      offset: type === "match" ? 15 : -15,
    },
    point: {
      size: 3,
      shape: "circle",
      style: {
        fill: Global.red,
        stroke: Global.red,
        lineWidth: 2,
      },
    },
    tooltip: {
      showMarkers: false,
    },
    state: {
      active: {
        style: {
          shadowBlur: 0,
          stroke: "#333",
          fill: Global.red,
        },
      },
    },
    meta: {
      rank: {
        min: 1,
        max: total,
        range: [1, 0],
      },
      doc_count: {
        alias: "Matches",
      },
    },
    interactions: [
      {
        type: "marker-active",
      },
    ],
  };

  if (type === "rank" || type === "match") {
    config.slider = {
      start: 0,
      end: 10,
    };
  }

  return data ? <Line style={style} autoFit={true} {...config} /> : null;
};

export default LinePlot;
